
export const COMMIT_HASH = 'bf35b8d';
export const BUILD_NUMBER = '20251117.1';
